const React = require('react');
const shallowCompare = require('react-addons-shallow-compare');

const classnames = require('classnames');
const DishListItem = require('./dish-list-item.jsx');
const DishCoupon = require('./dish-coupon.jsx');
const backArray = require('../../asset/images/hot-arrow.svg');
import FormattedMessage from '@/intl/formatted-message';
import dishText from '../../intl/messages/dish';
import defaultLogo from '../../asset/images/dish_img_default.svg';
import ScrollerMenu from '../../container/dish-scroller-menu/scrollerMenu';
import HttpsProtocolImage from '../common/https-protocol-image.jsx';
require('./dish-scroller.scss');

module.exports = React.createClass({
  displayName: 'DishScroller',
  propTypes: {
    activeDishTypeId: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
    ]).isRequired,
    activeDishTypeIdIndex: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
    ]).isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    dishesData: React.PropTypes.array.isRequired,
    onScrolling: React.PropTypes.func,
    onScroll: React.PropTypes.func.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    reinstateUndefined: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    getMarketCoupon: React.PropTypes.func.isRequired,
    marketList: React.PropTypes.object,
    diningForm: React.PropTypes.number,
    theme: React.PropTypes.string,
    shopInfo: React.PropTypes.object,
    load: React.PropTypes.object,
    showHotSpan: React.PropTypes.func,
    soldTopDishList: React.PropTypes.array,
    showHandleInput: React.PropTypes.func,
    showAlreadyGotCoupon: React.PropTypes.func,
    isHDL: React.PropTypes.bool,
    isZc: React.PropTypes.bool,
    hasAds: React.PropTypes.bool,
  },
  getDefaultProps() {
    return {};
  },
  getInitialState() {
    return {
      distance: window.innerHeight - 84,
      dishClass: '',
      dishScrollerHeight: null,
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onDishBtnTap(dishData, action) {
    const { onOrderBtnTap, onPropsBtnTap } = this.props;
    if (action) {
      this.onOrderDishUpdateInfo = {
        dishData,
        action,
      };
      onOrderBtnTap(dishData, action, false);
    } else {
      onPropsBtnTap(dishData);
    }
  },
  onImageBtnTap(dish) {
    if (this._cache && this._cache.isScrolling) {
      return;
    }

    this.props.onImageBtnTap(dish);
  },
  buildDishElements(
    activeDishTypeId,
    activeDishTypeIdIndex,
    dishTypesData,
    dishesData,
    onDishBtnTap,
  ) {
    const {
      theme,
      shopInfo,
      onScroll,
      onScrolling,
      marketList,
      changeShowData,
      saveOrderChangeItem,
      reinstateUndefined,
      isDataInitOver,
      isZc,
      hasAds,
    } = this.props;
    const hotDishElement = this.buildHotDishElements(theme);
    const { isOldMarketing } = shopInfo;
    function getDishTypeTitle(dishTypeData) {
      if (dishTypeData.desc) {
        return (
          <span>
            {dishTypeData.name}{' '}
            <span className="dish-type-desc">{`(${dishTypeData.desc})`}</span>
          </span>
        );
      }

      return <span>{dishTypeData.name}</span>;
    }

    if (isDataInitOver) {
      const newDishTypesData = [];
      const dishesReactObj = {};
      dishTypesData.forEach(dishTypeData => {
        const obj = { ...dishTypeData };
        const { id, dishIds } = { ...obj };
        if (!dishIds || dishIds.length === 0) return;
        const itemLi = (
          <li key={`${id}`} data-id={id} className="dish-item-type">
            {getDishTypeTitle(dishTypeData)}
          </li>
        );
        obj.reactObj = itemLi;
        obj.dishAry = [];
        const newDishIds = [];
        if (!!dishIds && dishIds.length > 0) {
          dishIds.forEach(dishId => {
            const dishData = dishesData.filter(dish => dish.id === dishId)[0];
            const dishDataCopy = { ...dishData };
            const { sameDishIndexs, proxyDishId } = dishDataCopy;
            if (!proxyDishId) {
              newDishIds.push(dishId);
              const sameRuleDishList = sameDishIndexs
                ? sameDishIndexs.map(dishIndex => dishesData[dishIndex])
                : null;

              const reactLi = (
                <li
                  className={classnames('dish-item-dish')}
                  key={`${id}-${dishId}`}
                  data-id={`${id}-${dishId}`}
                >
                  <DishListItem
                    changeShowDataItems={this.props.changeShowDataItems}
                    theme={theme}
                    sameRuleDishList={sameRuleDishList}
                    dishData={dishData}
                    onOrderBtnTap={onDishBtnTap}
                    onPropsBtnTap={onDishBtnTap}
                    onImageBtnTap={this.props.onImageBtnTap}
                    marketList={this.props.marketList}
                    diningForm={this.props.diningForm}
                    hotTag={false}
                    num={0}
                    showHandleInput={this.props.showHandleInput}
                    setNoMore={this.props.setNoMore}
                    isHDL={this.props.isHDL}
                  />
                </li>
              );
              dishesReactObj[`${id}-${dishId}`] = reactLi;
              dishDataCopy.reactObj = reactLi;

              obj.dishAry.push(dishDataCopy);
            }
          });
        }
        obj.dishIds = newDishIds;
        newDishTypesData.push(obj);
      });

      return (
        <ScrollerMenu
          reinstateUndefined={reinstateUndefined}
          saveOrderChangeItem={saveOrderChangeItem}
          dishId={activeDishTypeId}
          dishIdIndex={activeDishTypeIdIndex}
          onOrderDishUpdateInfo={this.onOrderDishUpdateInfo}
          onScroll={onScroll}
          onScrollingTitleAction={onScrolling}
          theme={theme}
          changeShowData={changeShowData}
          marketList={marketList}
          isHDL={this.props.isHDL}
          dishesData={dishesData} // snail 新增，将数据传递过去方便计算
          dishTypesData={newDishTypesData} // snail 新增，将数据传递过去，方便计算
          dishesReactObj={dishesReactObj} // snail 新增，将数据传递过去，方便计算
          isZc={isZc} // 是否正餐
          hasAds={hasAds}
        >
          {((isOldMarketing &&
            shopInfo.marketCoupon &&
            shopInfo.marketCoupon.coupId) ||
            (!isOldMarketing &&
              shopInfo.couponList &&
              shopInfo.couponList.length > 0)) && (
            <DishCoupon
              shopInfo={shopInfo}
              getMarketCoupon={this.props.getMarketCoupon}
              firstStatus={0}
              hiddenCouponsList={this.props.hiddenCouponsList}
              showCouponsList={this.props.showCouponsList}
              couponType={this.props.couponType}
              showAlreadyGotCoupon={this.props.showAlreadyGotCoupon}
            />
          )}
          {hotDishElement}
          {/* {<div scrollerMenuMain>{menuLiAll}</div>} */}
        </ScrollerMenu>
      );
    }

    return null;
  },

  buildHotDishElements(theme) {
    // 热销菜品
    if (this.props.soldTopDishList.length === 0) {
      return false;
    }

    return (
      <ul
        className="dish-list dish-list-hot clearfix"
        style={{ marginBottom: 0 }}
      >
        <li className="dish-item-type" style={{ marginBottom: 0 }}>
          <span className="hot-icon">
            <FormattedMessage {...dishText.dishguessYouLike} />
          </span>
        </li>
        <li
          className="hot-dish"
          style={{
            padding: theme === 'default' ? '10px 10px 0' : '10px 15px 0',
          }}
        >
          {this.props.soldTopDishList.length !== 0 &&
            this.props.soldTopDishList.map((item, index) => {
              const imgStyle =
                item.smallImgUrl || item.largeImgList[0]
                  ? 'mediuImg_'
                  : 'smallImg_';

              return (
                <div
                  className="dish-on-selling--modify is-hotdish"
                  key={index}
                >
                  <div className="dish-item-img o-mr">
                    <HttpsProtocolImage
                      src={
                        item.smallImgUrl ||
                        item.largeImgList[0] ||
                        defaultLogo
                      }
                      alt=""
                      className={imgStyle}
                    />
                  </div>
                </div>
              );
            })}
          {/* icon 箭头图标 */}
          <div
            className="hot-arrow-box"
            onTouchTap={event => {
              this.props.showHotSpan(event);
            }}
          >
            <div className="hot-arrow">
              <img src={backArray} alt="" />
            </div>
          </div>
        </li>
      </ul>
    );
  },
  render() {
    const {
      activeDishTypeId,
      activeDishTypeIdIndex,
      dishTypesData,
      dishesData,
    } = this.props;
    const dishElements = this.buildDishElements(
      activeDishTypeId,
      activeDishTypeIdIndex,
      dishTypesData,
      dishesData,
      this.onDishBtnTap,
    );
    return (
      <div className="dish-scroller">
        <div className="copyright copyright--dish-scroller">{dishElements}</div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-scroller.jsx